import { createAction } from 'redux-actions';

/*COMMON*/
export const CHANGE_SCREEN_SIZE = 'CHANGE_SCREEN_SIZE';
export const changeScreenSize = createAction(CHANGE_SCREEN_SIZE);

export const RESET_PROCESS_ERROR = 'RESET_PROCESS_ERROR';
export const resetProcessError = createAction(RESET_PROCESS_ERROR);

/*NAVIGATION*/
export const CHANGE_CURRENT_PATH = 'CHANGE_CURRENT_PATH';
export const changeCurrentPath = createAction(CHANGE_CURRENT_PATH);

/*LOGIN AUTH*/
export const FETCH_USER = 'FETCH_USER';
export const fetchUser = createAction(FETCH_USER);
export const FAIL_FETCH_USER = 'FAIL_FETCH_USER';
export const failFetchUser = createAction(FAIL_FETCH_USER);

export const RESET_AUTH = 'RESET_AUTH';
export const resetAuth = createAction(RESET_AUTH);
export const LOGIN = 'LOGIN';
export const login = createAction(LOGIN);
export const LOGOUT = 'LOGOUT';
export const logout = createAction(LOGOUT);


/*MAIN LIST*/
export const FETCH_MAIN_LIST = 'FETCH_MAIN_LIST';
export const fetchMainList = createAction(FETCH_MAIN_LIST);
export const FAIL_FETCH_MAIN_LIST = 'FAIL_FETCH_MAIN_LIST';
export const failFetchMainList = createAction(FAIL_FETCH_MAIN_LIST);
export const SET_MAIN_LIST_DATA = 'SET_MAIN_LIST_DATA';
export const setMainListData = createAction(SET_MAIN_LIST_DATA);
export const RESET_MAIN_LIST_STATE = 'RESET_MAIN_LIST_STATE';
export const resetMainListState = createAction(RESET_MAIN_LIST_STATE);

export const UPDATE_DATE = 'UPDATE_DATE';
export const updateDate = createAction(UPDATE_DATE);
export const FAIL_UPDATE_DATE = 'FAIL_UPDATE_DATE';
export const failUpdateDate = createAction(FAIL_UPDATE_DATE);
export const SUCCESS_UPDATE_DATE = 'SUCCESS_UPDATE_DATE';
export const successUpdateDate = createAction(SUCCESS_UPDATE_DATE);

/*FORMS*/
export const SEND_FORMS = 'SEND_FORMS';
export const sendForms = createAction(SEND_FORMS);
export const FAIL_SEND_FORMS = 'FAIL_SEND_FORMS';
export const failSendForms = createAction(FAIL_SEND_FORMS);
export const SUCCESS_SEND_FORMS = 'SUCCESS_SEND_FORMS';
export const successSendForms = createAction(SUCCESS_SEND_FORMS);
export const CLEAR_FORMS = 'CLEAR_FORMS';
export const clearForms = createAction(CLEAR_FORMS);


// WEBPACK FOOTER //
// ./src/actions/index.js